module.exports = __webpack_public_path__ + "img/img-stop-petro.1be1983f.png";